import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { PopupModule } from '~common-store/modules/popup';

@Component({})
export default class PopupMixin extends Vue {
    isActive(popupName: string) {
        // popup is shown when it is requested and once the loading of data is finished
        return PopupModule.popupRequested === popupName;
    }
}
